import '../../styles/globals.css'
import { TextField, Button, Box, Typography, Paper } from '@mui/material'
import karmaStyles from '../../styles/KarmaPool.module.css'
import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';

function HomepageLogin() {
    const [username, setUsername] = useState('nope');
    const [password, setPassword] = useState('nope');

    const [loginResponse, setLoginResponse] = useState('');

    const karmaContext = useKarmaPoolContext();

    const handleUsernameChange = (event) => {
        setUsername(event.target.value);
    };

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };

    const handleSubmit = (event) => {
        // Prevent page reload
        event.preventDefault();

        console.log("Logging in with username: " + username + " and password: " + password);

        fetch(karmaContext.getURLBaseAuthPath() + 'auth/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                "username": username,
                "password": password
            }),
        }).then((response) => response.json())
            .then((data) => {
                console.log("Login gave auth token: " + data);
                // Change browser page to /dashboard if contains token
                if (data["token"] != null) {
                    window.localStorage.setItem("jwtAuthToken", "Bearer " + data["token"]);
                    window.location.href = "/karma/dashboard";
                }
                else {
                    setLoginResponse("username or password incorrect");
                }
            })
            .catch((err) => {
                setLoginResponse("Login failed. Please try again.");
                console.log(err.message);
            });
    }

    return (
        <>
            <Box className={karmaStyles.homepageBox} sx={{ paddingTop: "0.5rem" }}>

                <p className={karmaStyles.homepageDescription}> <strong>Login</strong> </p>
                <Box>
                    <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                        <div>
                            <Box sx={{}}>
                                <TextField
                                    sx={{
                                        margin: "0.25rem",
                                        width: "11rem", input: { color: 'white' },
                                        label: { color: 'white' }
                                    }}
                                    id="username"
                                    label="Username"
                                    placeholder="username"
                                    variant='filled'
                                    onChange={handleUsernameChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                                <TextField
                                    sx={{
                                        margin: "0.25rem",

                                        width: "11rem", input: { color: 'white' },
                                        label: { color: 'white' }
                                    }}
                                    id="password"
                                    label="Password"
                                    type="password"
                                    placeholder="password"
                                    variant='filled'
                                    onChange={handlePasswordChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Box>
                            <Button
                                type="submit"
                                variant="contained"
                                color="info"
                                sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "1.0rem", marginBottom: "0.75rem" }}>
                                Log in
                            </Button>
                        </div>
                    </form>
                </Box>
            </Box>
            <Paper sx={{ marginTop : "1.0rem"}} />
            <Typography variant="body1" color="red" sx={{ color: "red", marginTop: "0.0em" }}>
                {loginResponse}
            </Typography>
            <Box>
                <p className={karmaStyles.homepageDescription}>
                    <Link to={"/karma"}>
                        back
                    </Link>
                </p>
            </Box>
        </>
    );
}

export default HomepageLogin;


